import React from 'react';
import '../scss/Benefits.scss';

const iconProps = {
  width: 30,
  height: 30,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

const benefits = [
  {
    title: 'Utvalda producenter',
    text: 'Nära samarbeten i Italien och Europa',
    icon: (
      <svg {...iconProps}>
        <path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15" />
        <path d="M5 19l7-7" />
      </svg>
    ),
  },
  {
    title: 'Leverans i hela landet',
    text: 'Till restauranger, caféer och butiker',
    icon: (
      <svg {...iconProps}>
        <path d="M3 6h11v10H3z" />
        <path d="M14 9h4l3 3v4h-7" />
        <circle cx="7" cy="17.5" r="1.8" />
        <circle cx="17" cy="17.5" r="1.8" />
      </svg>
    ),
  },
  {
    title: 'Personlig service',
    text: 'En pålitlig partner för din verksamhet',
    icon: (
      <svg {...iconProps}>
        <circle cx="12" cy="8" r="3.5" />
        <path d="M5 20c1-4 4-6 7-6s6 2 7 6" />
      </svg>
    ),
  },
  {
    title: 'Kunskap & inspiration',
    text: 'Hjälp att bygga meny och sortiment',
    icon: (
      <svg {...iconProps}>
        <path d="M4 5h6a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H4z" />
        <path d="M20 5h-6a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h6z" />
      </svg>
    ),
  },
];

const Benefits: React.FC = () => (
  <section className="benefits" aria-label="Därför Accordi">
    {benefits.map((b) => (
      <div key={b.title} className="benefit">
        <span className="benefit__icon">{b.icon}</span>
        <div>
          <div className="benefit__title">{b.title}</div>
          <div className="benefit__text">{b.text}</div>
        </div>
      </div>
    ))}
  </section>
);

export default Benefits;